"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewsList = void 0;
var react_1 = __importStar(require("react"));
var react_2 = require("@chakra-ui/react");
var axios_1 = __importDefault(require("axios"));
var react_router_1 = require("react-router");
var NewsList = function () {
    var _a;
    var _b = (0, react_1.useState)(null), NewsDatas = _b[0], setNewsDatas = _b[1];
    var _c = (0, react_1.useState)(true), isNewsLoading = _c[0], setIsNewsLoading = _c[1];
    var params = (0, react_router_1.useParams)();
    var shopCode = (_a = params.shop_code) !== null && _a !== void 0 ? _a : "main";
    var path = "/api/news";
    if (params.shop_code)
        path += "/" + params.shop_code;
    (0, react_1.useEffect)(function () {
        axios_1.default
            .get(path, { params: { limit: 5 } })
            .then(function (response) {
            setNewsDatas(response.data);
            console.log(response.data);
        })
            .catch()
            .finally(function () {
            setIsNewsLoading(false);
        });
    }, []);
    return (react_1.default.createElement(react_2.Box, null,
        react_1.default.createElement(react_2.Box, { display: "flex", alignItems: "center" },
            react_1.default.createElement(react_2.Text, { fontWeight: "bold", fontSize: "2.2rem", marginRight: "2.4rem" }, "\u304A\u77E5\u3089\u305B"),
            react_1.default.createElement(react_2.Button, { as: "a", href: "/" + (params.shop_code || "main") + "/news", type: "button", colorScheme: "orange", variant: "outline", _hover: {
                    color: "orange.700",
                    background: "rgba(249, 184, 18 ,0.1)",
                } }, "\u304A\u77E5\u3089\u305B\u4E00\u89A7")),
        react_1.default.createElement(react_2.List, null, NewsDatas ? (NewsDatas === null || NewsDatas === void 0 ? void 0 : NewsDatas.news.map(function (data) {
            return (react_1.default.createElement(react_2.ListItem, { mt: "1.5rem" },
                react_1.default.createElement(react_2.Box, { display: "flex", alignItems: "center" },
                    react_1.default.createElement(react_2.Text, { fontSize: "1.2rem", lineHeight: "1.2rem", marginRight: "1.3rem" }, data.released.year + "." + data.released.month + "." + data.released.day),
                    data.type === "important" && (react_1.default.createElement(react_2.Text, { fontSize: "1.2rem", lineHeight: "1.2rem", padding: "2px", marginRight: "1.3rem", color: "red", border: "1px", borderColor: "red" }, "\u91CD\u8981")),
                    shopCode === "main" &&
                        data.shop.code !== "main" && (react_1.default.createElement(react_2.Text, { fontSize: "1.2rem", lineHeight: "1.2rem", color: "gray" }, "" + data.shop.name))),
                data.contents ? (react_1.default.createElement(react_2.Link, { href: "/" + data.shop.code + "/news/" + data.id, fontSize: "1.5rem", textDecoration: "underline" }, data.title)) : (react_1.default.createElement(react_2.Text, { fontSize: "1.5rem" }, data.title))));
        })) : (react_1.default.createElement(react_2.Box, { textAlign: "center" },
            react_1.default.createElement(react_2.CircularProgress, { isIndeterminate: true, color: "#F9B812", mx: "auto", thickness: "4px" }))))));
};
exports.NewsList = NewsList;
